/**
 * 독립형 옵션 핸들러
 * 옵션이 선택될때마다 variant를 호출해서 optionSelectedProduct를 생성
 */
import { BaseOptionHandler } from './BaseOptionHandler';

export class IndependentOptionHandler extends BaseOptionHandler {
    /**
     * 옵션 선택 시: 각 옵션 선택마다 즉시 variant 호출하여 상품 생성
     */
    async onOptionSelect(props) {
        const { 
            optionIndex,
            selectedIdx, 
            productOptions, 
            renderableOptions,
            textAndFileOptions,
            allVariants,
            optionSelectedProductList,
            setProductOptions, 
            setRenderableOptions,
            setOptionSelectedProductList,
            fetchOptionVariant,
        } = props;
        const selectedOption = renderableOptions[optionIndex];
        const selectedOptionValue = selectedOption.value[selectedIdx];

        const combination = selectedOption?.optionName + ' - ' + selectedOptionValue?.optionText;
        // 옵션 상태 업데이트
        if (combination) {
            // 이미 존재하는 combination이면 그냥 종료
            if (optionSelectedProductList.some(product => product.combination === combination)) {
                this.combinationAlreadyExistsToast();
                return;
            }
            // 최대 품목 개수 체크
            if (optionSelectedProductList.length === this.MAX_QUANTITY) {
                this.maxNumberOfProductsToast();
                return;
            }
            
            // 해당 옵션의 variant 호출
            let variantId = '';
            try {
                const variantResponse = await fetchOptionVariant({ 
                    itemId: this.itemId, 
                    options: { 
                        [selectedOption.optionName]: { 
                            value: selectedOptionValue?.optionText, 
                            required: selectedOption.required 
                        } 
                    } 
                });
                variantId = variantResponse?.variant_id || '';
                if (variantId.length === 0) {
                    this.setToastMessage('상품 정보를 불러오는데 실패했어요');
                    this.setIsToastVisible(true);
                    return;
                }
                // 상품 추가
                setOptionSelectedProductList(prev => [...prev, {
                    productName: renderableOptions[optionIndex].required ? this.productInfo?.name : renderableOptions[optionIndex]?.value[selectedIdx]?.optionText,
                    combination: combination,
                    noOptionText: !renderableOptions[optionIndex].required,
                    optionValueList: [selectedOptionValue?.optionText],
                    textOptions: textAndFileOptions,
                    quantity: 1,
                    setQuantity: (quantity) => this.handleQuantityChange(combination, quantity),
                    price: this.productInfo?.price,
                    additionalPrice: variantResponse?.additional_price || 0,
                    processProductDeleteClicked: () => this.handleProductDeleteClicked(combination),
                    variantId: variantId,
                }]);
            } catch (error) {
                console.error('Failed to fetch variant code:', error);
                this.setToastMessage('상품 정보를 불러오는데 실패했어요');
                this.setIsToastVisible(true);
                return;
            }
        }
    }

    async onAddToCartClicked(props) {
        const {
            postCafe24ProductStockCheck,
            partnerId,
            optionSelectedProductList,
            productOptions,
            renderableOptions,
            sendAddProductWithOptionsToCart,
            chatbot,
            chatUserId,
            navigate
        } = props;

        const isProductSelling = await postCafe24ProductStockCheck(partnerId, this.productInfo.itemId);
        if (isProductSelling?.selling === "F") {
            this.setToastMessage('품절된 상품입니다');
            this.setIsToastVisible(true);
            sessionStorage.removeItem('product-option');
            navigate(`/chat/${chatbot.chatbotId}/${chatUserId}`)
            return;
        }

        // 필수 옵션을 선택 안 했거나, 필수인 textOption 을 입력 안 했으면 경고
        const hasRequiredOptionSelectedProduct = optionSelectedProductList.filter(product => !product.noOptionText).length > 0;
        const hasEmptyRequiredTextOptionInput = optionSelectedProductList.filter(product => {
            return product.textOptions.some(textOption => textOption.required && textOption.selectedValue === '');
        }).length > 0;
        if (productOptions.length > 0 && !hasRequiredOptionSelectedProduct) {
            this.setToastMessage('필수 옵션을 선택해주세요');
            this.setIsToastVisible(true);
            return;
        }
        // 독립형 옵션인 경우, 모든 필수 옵션을 선택해야 함
        const requiredOptionSelectedProductCountForIndependentOption = optionSelectedProductList.filter(product => !product.noOptionText).length;
        if (requiredOptionSelectedProductCountForIndependentOption !== renderableOptions.filter(option => option.required).length) {
            this.setToastMessage('필수 옵션을 선택해주세요');
            this.setIsToastVisible(true);
            return;
        }

        if (hasEmptyRequiredTextOptionInput) {
            this.setToastMessage('필수 옵션을 입력해주세요');
            this.setIsToastVisible(true);
            return;
        }
        sendAddProductWithOptionsToCart(this.productInfo, optionSelectedProductList);
        sessionStorage.removeItem('product-option');
        navigate(`/chat/${chatbot.chatbotId}/${chatUserId}`)
    }
}